var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1429 1.28571V16.7143H1.28571V1.28571H14.1429ZM14.1429 0H1.28571C0.944722 0 0.617695 0.135459 0.376577 0.376577C0.135459 0.617695 0 0.944722 0 1.28571V16.7143C0 17.0553 0.135459 17.3823 0.376577 17.6234C0.617695 17.8645 0.944722 18 1.28571 18H14.1429C14.4838 18 14.8109 17.8645 15.052 17.6234C15.2931 17.3823 15.4286 17.0553 15.4286 16.7143V1.28571C15.4286 0.944722 15.2931 0.617695 15.052 0.376577C14.8109 0.135459 14.4838 0 14.1429 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21411 13.4999H4.49983V14.7857H3.21411V13.4999ZM10.9284 13.4999H12.2141V14.7857H10.9284V13.4999ZM3.21411 10.2857H4.49983V11.5714H3.21411V10.2857ZM10.9284 10.2857H12.2141V11.5714H10.9284V10.2857ZM3.21411 7.07138H4.49983V8.35709H3.21411V7.07138ZM7.07125 13.4999H8.35697V14.7857H7.07125V13.4999ZM7.07125 10.2857H8.35697V11.5714H7.07125V10.2857ZM7.07125 7.07138H8.35697V8.35709H7.07125V7.07138ZM10.9284 7.07138H12.2141V8.35709H10.9284V7.07138ZM3.21411 3.21423H12.2141V5.1428H3.21411V3.21423Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.d467109faf7ddda99a02583363862008.svg";
export { ForwardRef as ReactComponent };